import React from 'react';
import * as XLSX from 'xlsx';
import AdminManageSettingsDataUpload from './admin-manage-settings-data-upload';
import AdminManageSettingsComparisonTable from './admin-manage-settings-comparison-table';
import * as adminService from '../../services/admin-service';

// ---------------------------------------------------------------------------
// Template download (client-side, no server round-trip)
// ---------------------------------------------------------------------------
const handleDownloadLeaseValidationRulesTemplate = () => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([[
    'Attribute Key', 'Display Name', 'Data Type', 'Absolute Min', 'Absolute Max',
    'Min Offset Days', 'Max Offset Days', 'Reference Point',
    'Min Reference Attribute Key', 'Min Reference Operator', 'Unit',
  ]]);
  ws['!cols'] = [
    { wch: 30 }, { wch: 25 }, { wch: 14 }, { wch: 14 }, { wch: 14 },
    { wch: 16 }, { wch: 16 }, { wch: 16 }, { wch: 28 }, { wch: 20 }, { wch: 10 },
  ];
  XLSX.utils.book_append_sheet(wb, ws, 'Template');
  XLSX.writeFile(wb, 'lease_validation_rules_template.xlsx');
};

const leaseValidationRulesConfig = {
  title: 'Manage Lease Validation Rules',
  description: 'Upload an Excel file containing broker verification lease validation rule bounds to compare with existing records and update as needed.',
  uploadTitle: 'Upload Lease Validation Rules File',
  entityName: 'lease validation rules',
  fileInputId: 'lease-validation-rules',
  templateDownload: {
    show: true,
    buttonText: 'Download Template File',
    onDownload: handleDownloadLeaseValidationRulesTemplate,
  },
  uploadService: adminService.uploadLeaseValidationRulesFile,
  bulkUpdateService: adminService.bulkUpdateLeaseValidationRules,
  downloadFileService: adminService.downloadLeaseValidationRulesFile,
  getFileInfoService: adminService.getLeaseValidationRulesFileInfo,
  idField: 'attribute_key',
  columns: [
    { field: 'attribute_key', label: 'Attribute Key', className: 'admin-pool-comparison-col-code' },
    { field: 'display_name', label: 'Display Name', className: 'admin-pool-comparison-col-name' },
    { field: 'category', label: 'Data Type', className: 'admin-pool-comparison-col-office' },
    { field: 'absolute_min', label: 'Absolute Min', className: 'admin-pool-comparison-col-description' },
    { field: 'absolute_max', label: 'Absolute Max', className: 'admin-pool-comparison-col-description' },
  ],
  viewAllConfig: {
    entityName: 'Lease Validation Rules',
    fetchAllService: adminService.fetchLeaseValidationRules,
    idField: 'attribute_key',
    searchFields: ['attribute_key', 'display_name', 'category'],
    columns: [
      { key: 'attribute_key', label: 'ATTRIBUTE KEY', width: '180px' },
      { key: 'display_name', label: 'DISPLAY NAME', width: '200px' },
      { key: 'category', label: 'DATA TYPE', width: '140px' },
      { key: 'absolute_min', label: 'ABSOLUTE MIN', width: '140px' },
      { key: 'absolute_max', label: 'ABSOLUTE MAX', width: '140px' },
      { key: 'min_reference_attribute_key', label: 'MIN REF ATTRIBUTE', width: '180px' },
      { key: 'min_reference_operator', label: 'MIN REF OPERATOR', width: '160px' },
    ],
    editable: true,
    editFields: ['absolute_min', 'absolute_max'],
    updateService: adminService.updateLeaseValidationRule,
    historyService: adminService.fetchLeaseValidationRuleHistory,
  },
};

const AdminManageLeaseValidationRules = () => {
  return (
    <AdminManageSettingsDataUpload
      config={leaseValidationRulesConfig}
      ComparisonTableComponent={AdminManageSettingsComparisonTable}
    />
  );
};

export default AdminManageLeaseValidationRules;
